import * as React from 'react';

function SvgIconReconciliationAssign(props) {
  return (
    <svg viewBox="0 0 23 19" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 .8a.7.7 0 01.7.7v16a.7.7 0 01-.7.7H1a.7.7 0 01-.7-.7v-16A.7.7 0 011 .8zm-.7 1.4H1.7v14.6h9.6V2.2zm-2.1 9.4a.7.7 0 01.095 1.394L9.2 13H3.8a.7.7 0 01-.095-1.394L3.8 11.6h5.4zm9.952-5.686l.071.063 2.829 2.828a.7.7 0 01.062.918l-.062.072-2.829 2.828a.7.7 0 01-1.052-.918l.062-.072L19.866 10 14.8 10a.7.7 0 01-.095-1.394L14.8 8.6l5.067-.001-1.634-1.632a.7.7 0 01-.062-.919l.062-.071a.7.7 0 01.919-.063zM9.2 5.6a.7.7 0 01.095 1.394L9.2 7H3.8a.7.7 0 01-.095-1.394L3.8 5.6h5.4z" />
    </svg>
  );
}

export default SvgIconReconciliationAssign;
